export default "__VITE_ASSET__2jOg$vOt__"